// Catálogo c_UsoCFDI del SAT (CFDI 4.0). Los más usados por la Academia van primero.
export const USOS_CFDI: [string, string][] = [
	["G03", "Gastos en general"],
	["D10", "Pagos por servicios educativos (colegiaturas)"],
	["S01", "Sin efectos fiscales"],
	["G01", "Adquisición de mercancías"],
	["G02", "Devoluciones, descuentos o bonificaciones"],
	["I01", "Construcciones"],
	["I02", "Mobiliario y equipo de oficina por inversiones"],
	["I03", "Equipo de transporte"],
	["I04", "Equipo de cómputo y accesorios"],
	["I05", "Dados, troqueles, moldes, matrices y herramental"],
	["I06", "Comunicaciones telefónicas"],
	["I07", "Comunicaciones satelitales"],
	["I08", "Otra maquinaria y equipo"],
	["D01", "Honorarios médicos, dentales y gastos hospitalarios"],
	["D02", "Gastos médicos por incapacidad o discapacidad"],
	["D03", "Gastos funerales"],
	["D04", "Donativos"],
	["D05", "Intereses reales pagados por créditos hipotecarios (casa habitación)"],
	["D06", "Aportaciones voluntarias al SAR"],
	["D07", "Primas por seguros de gastos médicos"],
	["D08", "Gastos de transportación escolar obligatoria"],
	["D09", "Depósitos en cuentas para el ahorro, primas de planes de pensiones"],
	["CP01", "Pagos"],
	["CN01", "Nómina"],
];
